import React, { Component } from 'react';
import styles from './user-settings.module.sass';
import { Table, Input, Button, Tooltip } from 'antd';
import {
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { STATUS } from '../../../../redux/constants';
import DetailsModal from './DetailsModal';
import { confirmDelete } from '../../../../shared-components/DeleteConfirm';
import moment from 'moment-timezone';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';

export class UserSettings extends Component {
  state = {
    showModal: false,
    searchQuery: '',
    selectedUser: null,
  };
  componentDidMount() {
    const { status, groupsStatus, departmentsStatus } = this.props;
    if (status === STATUS.IDLE) {
      if (this.props?.user?.is_organization_admin === true) {
        this.props.loadUsers();
      }
    }
    if (groupsStatus === STATUS.IDLE) {
      //this.props.loadGroups();
    }
    if (departmentsStatus === STATUS.IDLE) {
      //this.props.loadDepartments();
    }
  }

  handleCreateClick = () => {
    this.setState({ showModal: true });
  };

  handleModalClose = () => {
    this.setState({ showModal: false, selectedUser: null });
  };

  handleSubmit = (data) => {
    const { selectedUser } = this.state;
    const user = {
      ...data,
      username: selectedUser?.username,
      department_id: data.department,
      // group_list: [data.group],
    };
    if (selectedUser) {
      this.props.updateUser(user);
    } else {
      this.props.createUser(user);
    }
    this.setState({ showModal: false });
    //this.props.loadUsers();
    setTimeout(() => {
      this.props.loadMySubscriptionPlan();
    }, 1000);
  };

  handleEditClick = (user) => {
    this.setState({ showModal: true, selectedUser: user });
  };

  handleDeleteClick = (user) => {
    confirmDelete({
      onOk: () => {
        this.props.deleteUser(user);
        setTimeout(() => {
          this.props.loadMySubscriptionPlan();
        }, 1000);
      },
    });
  };

  handleSearchQueryChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  handleReInvite = (user) => {
    this.props.inviteUser(user.username);
  };

  getFilteredUsers = () => {
    const { users } = this.props;
    const { searchQuery } = this.state;
    const query = searchQuery.trim().toLowerCase();
    if (!query) return users;
    return users.filter((u) =>
      `${u.first_name} ${u.last_name}`.toLowerCase().includes(query),
    );
  };

  getColumns = () => {
    return [
      {
        title: <ColumnTitle columnName="First Name" />,
        dataIndex: 'first_name',
        key: 'first_name',
      },
      {
        title: <ColumnTitle columnName="Last Name" />,
        dataIndex: 'last_name',
        key: 'last_name',
      },
      // {
      //   title: 'Groups',
      //   dataIndex: 'group_list',
      //   key: 'group_list',
      //   render: (groups) => (groups && groups.length ? groups[0].name : ''),
      // },
      {
        title: <ColumnTitle columnName="Email" />,
        dataIndex: 'email',
        key: 'email',
      },
      // {
      //   title: 'Role',
      //   dataIndex: 'role',
      //   key: 'role',
      // },
      // {
      //   title: 'Department',
      //   dataIndex: 'department',
      //   key: 'department',
      // },
      {
        title: <ColumnTitle columnName="Actions" />,
        key: 'actions',
        render: (item) => (
          <div
            className={styles.action_buttons}
            style={{ display: 'inline-table', minWidth: 150, textAlign: 'end' }}
          >
            <Tooltip title="Re-invite user by email">
              {/*{!item.last_login &&*/}
              {/*  item?.date_joined &&*/}
              {/*  moment().diff(moment(item?.date_joined), 'hours') >= 72 && (*/}
              <Button
                type="link"
                onClick={() => this.handleReInvite(item)}
                size="small"
                style={{ border: 0 }}
              >
                Re-invite
              </Button>
              {/*)}*/}
            </Tooltip>
            <Tooltip title="Edit User">
              <EditOutlined onClick={() => this.handleEditClick(item)} />
            </Tooltip>
            &nbsp;&nbsp;
            <Tooltip title="Delete User">
              <DeleteOutlined onClick={() => this.handleDeleteClick(item)} />
            </Tooltip>
          </div>
        ),
      },
    ];
  };

  render() {
    const { status, groups, departments } = this.props;
    const { showModal, searchQuery, selectedUser } = this.state;
    const loading = status === STATUS.LOADING;

    return (
      <div className={styles.container}>
        <DetailsModal
          user={selectedUser}
          show={showModal}
          groups={groups}
          departments={departments}
          inviteUser={this.props.inviteUser}
          onCancel={this.handleModalClose}
          onSubmit={this.handleSubmit}
        />
        <div className={styles.top_section}>
          <Input
            placeholder="Search Users"
            prefix={<SearchOutlined />}
            className={styles.search_input}
            value={searchQuery}
            onChange={this.handleSearchQueryChange}
          />
          {this.props?.user?.is_organization_admin === true &&
          this.props.mySubscriptionPlan?.can_create_user ? (
            <Button type="primary" onClick={this.handleCreateClick}>
              + Add New User
            </Button>
          ) : (
            ''
          )}
          {this.props?.user?.is_organization_admin === true &&
          this.props.mySubscriptionPlan?.can_create_user === false ? (
            <Tooltip
              title={
                'Seat limit reached. Contact us at sales@silentpush.com to increase seat limit.'
              }
            >
              <Button
                disabled
                type="primary"
                //onClick={this.handleCreateClick}
              >
                + Add New User
              </Button>
            </Tooltip>
          ) : (
            ''
          )}
        </div>

        <Table
          columns={this.getColumns()}
          dataSource={this.getFilteredUsers()}
          loading={loading}
          pagination={false}
        />
      </div>
    );
  }
}

export default UserSettings;
